import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GalleryLayout11 } from '@components/gallery/components/gallery-layout-11/model';
import { ImageComponent } from '@shared/components/image';
import { QuoteComponent } from '@shared/components/quote';

@Component({
  selector: 'app-gallery-layout-11',
  imports: [QuoteComponent, ImageComponent],
  templateUrl: './gallery-layout-11.component.html',
  styleUrl: './gallery-layout-11.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout11Component {
  readonly data = input.required<GalleryLayout11>();
}
